import { supabase } from '../lib/supabase';

export const auditService = {
  /**
   * Log an audit entry.
   * @param {object} entry - { action, entityType, entityId, entityName, oldValues, newValues }
   */
  async log({ action, entityType, entityId = null, entityName = null, oldValues = null, newValues = null }) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) return;

      const { error } = await supabase?.from('audit_trail')?.insert({
        user_id: user?.id,
        user_email: user?.email,
        action,
        entity_type: entityType,
        entity_id: entityId || null,
        entity_name: entityName,
        old_values: oldValues ? oldValues : null,
        new_values: newValues ? newValues : null,
      });
      if (error) console.error('Audit log error:', error?.message);
    } catch (err) {
      console.error('Audit log failed:', err?.message);
    }
  },

  /** Fetch audit trail with optional filters */
  async getAll({ entityType = null, entityId = null, limit = 100, offset = 0 } = {}) {
    let query = supabase?.from('audit_trail')?.select('*, user_profiles(full_name, email, role)', { count: 'exact' })?.order('created_at', { ascending: false })?.range(offset, offset + limit - 1);

    if (entityType) query = query?.eq('entity_type', entityType);
    if (entityId)   query = query?.eq('entity_id', entityId);

    const { data, error, count } = await query;
    if (error) throw error;
    return { data: data || [], count: count || 0 };
  },

  /** Subscribe to real-time audit trail inserts */
  subscribeToNew(callback) {
    return supabase?.channel('audit_trail_realtime')?.on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'audit_trail' },
        (payload) => callback(payload?.new)
      )?.subscribe();
  },

  unsubscribe(channel) {
    if (channel) supabase?.removeChannel(channel);
  },
};
